export default {"src":"/_next/static/media/0x3a287a06c66f9e95a56327185ca2bdf5f031cecd.6afc9bd0.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};